export default "__VITE_ASSET__D6HLhH5K__"